export const externalRoutesGlobal = [
    {
        path: '/third-party/recording-details-h5',
        name: 'externalRecordingDetailsH5',
    },
];
